import ReactGA from "react-ga4";

// Page view tracking
export const trackPageView = (path: string) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

// Feature tracking
export const trackFeature = (
    featureName: string,
    action: string,
    additionalData?: Record<string, any>,
) => {
    ReactGA.event({
        category: "Feature",
        action: action,
        label: featureName,
        ...additionalData,
    });
};

// Common feature tracking functions
export const trackPostCreation = (postType: string) => {
    trackFeature("Post", "Create", { postType });
};

export const trackComment = (postId: string) => {
    trackFeature("Comment", "Create", { postId });
};

export const trackProfileUpdate = (section: string) => {
    trackFeature("Profile", "Update", { section });
};

export const trackSearch = (query: string) => {
    trackFeature("Search", "Perform", { query });
};

export const trackConnection = (action: "connect" | "disconnect", userId: string) => {
    trackFeature("Connection", action, { userId });
};

export const trackEducation = (action: string, courseId?: string) => {
    trackFeature("Education", action, { courseId });
};

export const trackMessaging = (action: string, recipientId?: string) => {
    trackFeature("Messaging", action, { recipientId });
};

// User engagement tracking
export const trackEngagement = (type: string, contentId: string) => {
    trackFeature("Engagement", type, { contentId });
};

// Error tracking
export const trackError = (errorType: string, errorMessage: string) => {
    trackFeature("Error", errorType, { errorMessage });
};
